<template>
	<div>
		<div class="table-btn-box">
			<div
				v-show="search"
				class="table-search-box">
					<el-input
						v-model.trim="value"
						:placeholder="'请输入搜索关键字'"></el-input>
					<el-button
						:type="'primary'"
						:icon="'el-icon-search'"
						@click="searchHandle"></el-button>
				</div>
				<div >
					<slot name="table-header"></slot>
				</div>
		</div>
		
		<el-table
			header-cell-class-name="table-head"
			style="width: 100%"
			:max-height="maxHeight"
			:data="currentData"
			@selection-change="handleSelectionChange"
			@sort-change = "sortHandle"
			ref="table"
		>
			<template v-if="showCheck">
				<el-table-column type="selection" width="40"> </el-table-column>
			</template>
			<template v-for="(v, i) in column">
				<el-table-column
					:label="v.label"
					:prop="v.prop"
					:sortable="v.sortable"
					:filters="v.filters"
					:filter-method="v.filterMethod"
					:width="v.width"
					:fixed="v.fixed"
					:key="i"
				>
					<template slot-scope="scope">
						<!-- 按钮 -->
						<template v-if="v.btns">
							<template v-for="(bv, bi) in v.btns">
								<a
									href="javascript:;"
									:class="
										typeof bv.class == 'function'
											? [...bv.class(scope), ['table-btn']]
											: ['table-btn', [...bv.class]]
									"
									@click="bv.action && bv.action(scope, $event, bi, v.btns)"
									:key="bi"
								>
									{{ typeof bv.label == "function" ? bv.label(scope) : bv.label }}
								</a>
							</template>
						</template>
						<!-- 文本 -->
						<template v-if="v.prop">
							{{ v.formatText?v.formatText(scope,v.prop) : scope.row[v.prop] }}
						</template>
						<!-- 图片 -->
						<template v-if="v.img">
							<img :src="scope.row[v.img]" alt="" width="60px">
						</template>
					</template>

					<template v-if="v.children">
						<template v-for="(o, p) in v.children">
							<el-table-column
								:label="o.label"
								:prop="o.prop"
								:width="o.width"
								:sortable="o.sortable"
								:filters="o.filters"
								:filter-method="o.filterMethod"
								:key="`${i}-${p}`"
							>
							</el-table-column>
						</template>
					</template>
				</el-table-column>
			</template>
		</el-table>
      <!-- :page-sizes="[10, 25, 50, 100]" -->
		<el-pagination
			v-show="pagination"
			class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      :layout="layout"
			:page-count="pageCount"
      :total="total?total:isAll?dt.length:null">
    </el-pagination>
	</div>
</template>
<script>
import { Table, TableColumn, Pagination, Input, Button } from "element-ui";
export default {
  name: "tableBox",
  props: {
    // 复选框
    showCheck: {
      type: Boolean,
      default: false,
    },
    column: {
      type: Array,
      default: ()=>[],
    },
    data: {
      type: Array,
      default: ()=>[],
    },
    maxHeight: {
      type: [String, Number],
      default: 500,
    },
	// 分页
		isAll:{
			type:Boolean,
			default:false
		},
		pagination:{
			type:Boolean,
			default:false
		},
		total:{
			type:Number,
			default:0
		},
		pageCount:{
			type:Number,
			default: null
		},
		pageSize:{
			type:Number,
			default: 10
		},
		layout:{
			type:String,
			default : 'total, prev, pager, next, jumper'
		},
		// 搜索
		search:{
			type:Boolean,
			default:false
		}
  },
  data() {
    return {
			dt:[],//所有数据
			currentData:[],//当前页数据
			currentPage:1,
			// pageSize: 10,
			value:'',

		};
  },
  methods: {
    // 复选框选择
    handleSelectionChange(arr) {
      this.$emit("selectionChang", arr);
    },
		// 分页
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			if( this.isAll ){
				this.pageSize = val;
				this.getCurrentData();
			}
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.$refs.table.bodyWrapper.scrollTop = 0;
			if(this.isAll){
				this.currentPage = val;
			}else{
				this.$emit('pageChange',val)
			}
			this.getCurrentData();
		},
		getCurrentData(){
			let {pageSize, currentPage, dt} = this;
			if( this.isAll ){
				this.currentData = dt.slice((currentPage-1)*pageSize, currentPage*pageSize);
			}else{
				this.currentData = dt;
			}
		},
		// 排序
		sortHandle({column,prop,order}){
			this.dt = this.data;
			if( order === 'ascending'){
				this.dt = this.dt.sort((a,b)=>{
					return String(a[prop]).localeCompare(String(b[prop]), 'zh');
				})
			}else if(order === 'descending'){
				this.dt = this.dt.sort((a,b)=>{
					return String(b[prop]).localeCompare(String(a[prop]), 'zh');
				})
			}
			this.getCurrentData();
		},
		// 搜索
		searchHandle(){
			let {value, isAll} = this;
			if( isAll ){
				this.dt = this.data.filter(v=>{
						let keys = Object.keys(v);
						let flag = false;
						keys.forEach(item=>{
								let o = v[item]?String(v[item]):'';
								if( o.includes( value ) ){
									flag = true;
									return;
								}
						})
						if(flag){return v};
				})
				this.getCurrentData();
				
			}
			this.$emit('searchClick',value);
		}
  },
	mounted(){
		
	},
	computed:{
		// dt:{
		// 	set(v){
		// 		return v;
		// 	},
		// 	get(){
		// 		return this.data;
		// 	}
		// }
	},
	watch:{
		data(v){
			// if(v.length>0){
				this.dt = v;
				this.getCurrentData();
			// }
		}
	},
  components: {
    elTable: Table,
    elTableColumn: TableColumn,
    elPagination: Pagination,
		elInput: Input,
		elButton: Button
  },
};
</script>
<style scoped>
.table-btn {
  /* color: #409EFF; */
}
</style>
<style>
.table-head {
  background: #f5f7fa !important;
}

.el-table__column-filter-trigger i {
  font-size: 16px;
}


.pagination{
	margin-top: 20px;
	display: flex;
	justify-content: flex-end;
}

.table-search-box{
	width: 300px;
	height: 40px;
	display: flex;
	
}
.table-btn-box{
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/tableBox.vue